export enum JOB_TYPE {
   ACTIVE_ITEM_ACCOUNT = 6
}